export type RecurrenceType = 'Weekly' | 'BiWeekly' | 'SemiMonthly' | 'Monthly';

export const RECURRENCE_TYPES: RecurrenceType[] = [
  'Weekly',
  'BiWeekly',
  'SemiMonthly',
  'Monthly',
];
